export default "__VITE_ASSET__UhiEcVYG__"